import { createContext } from 'react'
const RoomSettingsContext = createContext<{
  roomSettings: any
  setRoomSettings: (value: any) => void
  showIntroModal: boolean
  setShowIntroModal: (value: boolean) => void
}>({
  roomSettings: {},
  setRoomSettings: () => {},
  showIntroModal: false,
  setShowIntroModal: () => {}
})
export { RoomSettingsContext }
